import { ref } from 'vue'

/** Whether a newer version of the app is installed and waiting to activate. */
const updateAvailable = ref(false)

let waitingWorker: ServiceWorker | null = null

/** Activate the waiting service worker, then reload the page. */
function refresh() {
  waitingWorker?.postMessage({ type: 'SKIP_WAITING' })
}

export function useVersionCheck() {
  return { updateAvailable, refresh }
}

/**
 * Register the version service worker and listen for updates. Called once at
 * app bootstrap (see `main.ts`). Skipped in dev, where the worker is not built.
 */
export function initVersionCheck() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload()
  })

  navigator.serviceWorker
    .register('/sw.js')
    .then((registration) => {
      // A new worker was already waiting when this page loaded (e.g. a tab was
      // left open across a deploy).
      if (registration.waiting && navigator.serviceWorker.controller) {
        waitingWorker = registration.waiting
        updateAvailable.value = true
        return
      }

      registration.addEventListener('updatefound', () => {
        const worker = registration.installing
        if (!worker) return

        worker.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) {
            waitingWorker = worker
            updateAvailable.value = true
          }
        })
      })
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error)
    })
}
